function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { throw: 1, return: 2, break: 3, continue: 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, catch: function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { get, isEmpty, some } from 'lodash';
import buildResponses from '@unite-us/surveyjs/dist/components/Renderer/buildResponses';
import { Icon } from '@unite-us/ui';
import StepHeader from '../../components/StepHeader';
import { SUPPORTING_INFO } from '../builder/constants';
import { setData, useAppCreateReferralContext } from '../../context/AppCreateReferralProvider';
import CreateReferralContainer from '../../components/CreateReferralContainer';
import fetchCoreGroupForms from '../../actions/Group/fetchCoreGroupForms';
import NavButtons from '../../components/NavButtons';
import FormForm from '../../common/form/FormForm';
import useCreateReferrals from '../../hooks/useCreateReferrals';
import { CALLBACKS } from '../../api/config';
import { hasOffPlatformReferrals } from '../builder/utils';
import './SupportingInfo.scss';
export default function SupportingInfo() {
  var navigate = useNavigate();
  var _useAppCreateReferral = useAppCreateReferralContext(),
    dispatch = _useAppCreateReferral.dispatch,
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    person = _useAppCreateReferral2.person,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    currentProvider = _useAppCreateReferral2.currentProvider,
    referrals = _useAppCreateReferral2.referrals,
    fieldsConfig = _useAppCreateReferral2.fieldsConfig,
    formResponses = _useAppCreateReferral2.formResponses;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    groupForms = _useState2[0],
    setGroupForms = _useState2[1];
  var formRefs = useRef({});
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    expandedFormCard = _useState4[0],
    setExpandedFormCard = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showErrors = _useState6[0],
    setShowErrors = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isDisabled = _useState8[0],
    setIsDisabled = _useState8[1];
  var formsRenderedRef = useRef(0);
  var providerId = currentProvider === null || currentProvider === void 0 ? void 0 : currentProvider.id;
  useEffect(function () {
    var serviceIds = referrals === null || referrals === void 0 ? void 0 : referrals.map(function (referral) {
      return referral.service.id;
    });
    fetchCoreGroupForms(providerId, serviceIds).then(function (data) {
      setGroupForms(data);
      if (isEmpty(data)) {
        setIsDisabled(false);
      }
      ;
    });
  }, [providerId, referrals]);
  var handleRef = useCallback(function () {
    if (isDisabled) {
      var totalForms = groupForms.length;
      formsRenderedRef.current += 1;
      if (formsRenderedRef.current === totalForms) {
        setIsDisabled(false);
      }
    }
  }, [isDisabled, groupForms.length]);

  // no dependencies in order to hide error message by checking hasErrors on every render of forms
  useEffect(function () {
    var hasErrors = some(formRefs === null || formRefs === void 0 ? void 0 : formRefs.current, function (form) {
      var _form$ref;
      return form === null || form === void 0 || (_form$ref = form.ref) === null || _form$ref === void 0 ? void 0 : _form$ref.hasErrors();
    });
    if (!hasErrors) {
      setShowErrors(false);
    }
    ;
  }, []);
  var _handleExpandChange = function handleExpandChange(index) {
    if (index === expandedFormCard) setExpandedFormCard(null);else {
      setExpandedFormCard(index);
    }
  };
  var goToReviewStep = function goToReviewStep() {
    navigate('/create/review');
  };
  var dispatchAssessmentResponses = function dispatchAssessmentResponses() {
    var responses = getAssessmentsResponses();
    dispatch(setData({
      formResponses: responses
    }));
    return responses;
  };
  var onButtonClick = function onButtonClick(back) {
    var dispatchedResponses = dispatchAssessmentResponses();
    if (back) {
      navigate('/create/builder');
    } else if (dispatchedResponses) {
      goToReviewStep();
    }
  };
  var getAssessmentsResponses = function getAssessmentsResponses() {
    var formResponses = {};
    var hasErrors = false;
    var forms = formRefs.current;
    Object.keys(forms).forEach(function (formId) {
      var formRef = forms[formId];
      if (formRef.ref.hasErrors()) {
        hasErrors = true;
      }
      var response = buildResponses(formRef.ref);
      if (!isEmpty(response)) {
        formResponses[formId] = {
          responses: response,
          form: groupForms.find(function (f) {
            return f.id === formId;
          })
        };
      }
    });
    if (hasErrors) {
      setShowErrors(true);
      return;
    }
    ;
    return formResponses;
  };
  var createReferrals = useCreateReferrals();
  var handleSaveDraftReferral = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var responses, onSaveDraftReferral;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            responses = dispatchAssessmentResponses();
            _context.next = 3;
            return createReferrals({
              draft: true,
              latestResponses: responses
            });
          case 3:
            onSaveDraftReferral = CALLBACKS.onSaveDraftReferral;
            onSaveDraftReferral && onSaveDraftReferral();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSaveDraftReferral() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(CreateReferralContainer, null, /*#__PURE__*/React.createElement(StepHeader, {
    header: 'Complete Assessments'
  }, SUPPORTING_INFO), /*#__PURE__*/React.createElement("div", {
    className: "px-12 pb-6"
  }, /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: function onBackClick() {
      return onButtonClick(true);
    },
    onForwardClick: function onForwardClick() {
      return onButtonClick(false);
    },
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Next",
    disabled: isDisabled,
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals)
  }), showErrors ? /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end responsive-max-width mx-auto mb-4"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "ExclamationTriangle",
    color: "#D0021B",
    className: "mr-2 mt-0.5",
    size: 12
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-red"
  }, "One or more assessments require your attention.")) : null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white border border-solid border-blue-border rounded mx-auto responsive-max-width"
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-supporting-details-step"
  }, /*#__PURE__*/React.createElement("div", null, groupForms.map(function (form, index) {
    var _formRefs$current$for;
    var formRef = formRefs === null || formRefs === void 0 || (_formRefs$current$for = formRefs.current[form.id]) === null || _formRefs$current$for === void 0 ? void 0 : _formRefs$current$for.ref;
    return /*#__PURE__*/React.createElement(FormForm, {
      id: "group-form-".concat(index),
      className: "custom-form-".concat(index),
      setRef: function setRef(ref) {
        formRefs.current = _objectSpread(_objectSpread({}, formRefs.current), {}, _defineProperty({}, form.id, ref));
        handleRef();
      },
      key: "".concat(form.id, "formform"),
      formId: form.id,
      groupId: providerId,
      handleExpandChange: function handleExpandChange() {
        return _handleExpandChange(index);
      },
      expanded: index === expandedFormCard,
      currentEmployee: currentEmployee,
      hasErrors: showErrors ? formRef === null || formRef === void 0 ? void 0 : formRef.hasErrors() : false,
      contextType: "case",
      contextPerson: person.id,
      response: formResponses === null || formResponses === void 0 ? void 0 : formResponses[form.id],
      usage_type: "referral_assessment"
    });
  })))), !isEmpty(groupForms) && /*#__PURE__*/React.createElement("div", {
    className: "pt-6"
  }, /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: function onBackClick() {
      return onButtonClick(true);
    },
    onForwardClick: function onForwardClick() {
      return onButtonClick(false);
    },
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Next",
    disabled: isDisabled,
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals)
  }))));
}
//# sourceMappingURL=SupportingInfo.js.map